<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">双机互联版MSTATION</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

     <div class="mstation-introduce-content">
       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">双机互联版MSTATION</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">
           双机互联版MSTATION属于精简版的集群方案，环境配置与普通高性能集群类似，但不需要机房，infiniband交换机以及存储设备，是一种性价比极高的集群解决方案。相对于单台MSTATION，其计算速度以及计算规模都有成倍的提升，例如普通的PBE计算，可以计算7000电子左右的体系，而对于HSE计算，可以计算500~600原子左右的体系。双机互联版MSTATION，基本配置与MSTATION相同，同时配备IB卡以及高速IB线。
         </p>
       </div>

       <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-img-png" src="../../assets/produce/doubleMstsation/double_mstsation_product.png">
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">硬件配置信息</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">硬件</th>
             <th class="mstation-introduce-text-th">双机互联版MSTATION</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU</td>
             <td class="mstation-introduce-text-td">双路Intel ® Xeon ® CPU E5-2620 v4</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">GPU</td>
             <td class="mstation-introduce-text-td">最多8路 NVIDIA ® GTX 3080Ti/3090</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">内存</td>
             <td class="mstation-introduce-text-td">最大512GB DDR4</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">IB卡</td>
             <td class="mstation-introduce-text-td">配备</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">IB线</td>
             <td class="mstation-introduce-text-td">配备</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">硬盘</td>
             <td class="mstation-introduce-text-td">8TB</td>
           </tr>
         </table>
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">购买双机互联版MSTATION的优势</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>高性价比。使用PWmat，双机互联版MSTATION无需专业的机房环境、infiniband交换机以及存储设备，其计算能力相当于200CPU核的服务器性能，而购置200CPU核的CPU服务器大约耗资50万。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>计算规模大。双机互联版MSTATION的计算规模以及计算速度相比于单台MSTATION都有极大的提升，例如普通的PBE计算，可以计算7000电子左右的体系，而对于HSE计算，可以计算500~600原子左右的体系。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>标准集群环境。双机互联版配置了标准的集群环境，配置SSH免密服务、NFS服务、NIS服务、NTP服务等，用户管理以及使用集群非常方便。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>节能省电。单台MSTATION的功率在1100W左右，所以双机互联版MSTATION不超过2500W，相对于CPU集群使用起来更加节能省电。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>双机互联版MSTATION也采用了开箱即用的模式，让用户从繁杂的计算配置以及软件安装中解放出来，可以投入更多的精力到科研中。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>预装 slurm 作业调度系统，满足各种后台调度需要。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>双机互联版MSTATION还预装了大量的计算模拟软件LAMMPS、CP2K、Quantum Espresso等开源软件。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>双机互联版MSTATION也秉承了单台MSTATION的一体化方案：从输入、系统分析、材料模拟、结果可视化都在一台机器上完成。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>完善的售后服务支持：对于各种集群问题以及PWmat的实用问题，我们都能及时反馈给您解决方案。</p>

       </div>
     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .mstation-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .mstation-introduce-background{
    margin-top: 70px;
  }
  .mstation-introduce-banner{
    overflow:hidden;
  }
  .mstation-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .mstation-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .mstation-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 50px;
    width: 300px;
  }
  .mstation-introduce-content-title{
    padding-top: 50px;
  }
  .mstation-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .mstation-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-fa{
    font-size: 16px;
    padding-right: 8px;
  }
  @media screen and (max-width:482px) {
    .mstation-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .mstation-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .mstation-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }

</style>